import { render, staticRenderFns } from "./RiskModelRuleForm.vue?vue&type=template&id=b7cca6de&scoped=true&"
import script from "./RiskModelRuleForm.vue?vue&type=script&lang=js&"
export * from "./RiskModelRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cca6de",
  null
  
)

export default component.exports